/**
 * Custom element: <variant-compare-price>
 * Shows RRP (compare-at price) and updates when the product variant changes.
 * Listens for theme:variant:change from the product form in the same section.
 */
(function () {
  function formatMoney(cents, format) {
    if (cents == null || cents === '') return '';
    var amount = (Number(cents) / 100).toFixed(2);
    var parts = amount.split('.');
    var intPart = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    var decPart = parts[1];
    if (!format || typeof format !== 'string') return intPart + '.' + decPart;
    return format
      .replace(/\{\{\s*amount\s*\}\}/, intPart + '.' + decPart)
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/, intPart)
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, intPart + '.' + decPart)
      .replace(/\{\{\s*amount_no_decimals_with_comma_separator\s*\}\}/, intPart)
      .replace(/\{\{\s*amount_with_apostrophe_separator\s*\}\}/, intPart.replace(/,/g, "'") + '.' + decPart);
  }

  class VariantComparePrice extends HTMLElement {
    constructor() {
      super();
      this._boundOnVariantChange = this._onVariantChange.bind(this);
      this._section = null;
    }

    connectedCallback() {
      this._section = this.closest('[data-section-id]');
      if (!this._section) return;
      this._amountEl = this.querySelector('[data-variant-compare-amount]');
      if (!this._amountEl) {
        var wrap = document.createElement('span');
        wrap.setAttribute('data-variant-compare-amount', '');
        this.appendChild(wrap);
        this._amountEl = wrap;
      }
      this._section.addEventListener('theme:variant:change', this._boundOnVariantChange);
    }

    disconnectedCallback() {
      if (this._section) {
        this._section.removeEventListener('theme:variant:change', this._boundOnVariantChange);
      }
    }

    _onVariantChange(evt) {
      var variant = evt.detail && evt.detail.variant;
      if (!variant) {
        this.classList.add('hide');
        return;
      }
      var compareAt = variant.compare_at_price;
      var price = variant.price;
      if (compareAt != null && price != null && compareAt > price) {
        var formatted = this._formatMoney(compareAt);
        this._amountEl.textContent = formatted;
        this.classList.remove('hide');
        this.style.display = '';
      } else {
        this.classList.add('hide');
        this.style.display = 'none';
      }
    }

    _formatMoney(cents) {
      var theme = window.theme;
      if (theme && theme.moneyFormat) {
        var str = formatMoney(cents, theme.moneyFormat);
        if (theme.settings && theme.settings.currency_code_enable && theme.currencyCode) {
          return str + ' ' + theme.currencyCode;
        }
        return str;
      }
      return formatMoney(cents);
    }
  }

  if (!window.customElements.get('variant-compare-price')) {
    window.customElements.define('variant-compare-price', VariantComparePrice);
  }

  /**
   * Custom element: <variant-sale-save>
   * Shows "Sale • Save [amount]" and updates when the product variant changes.
   */
  class VariantSaleSave extends HTMLElement {
    constructor() {
      super();
      this._boundOnVariantChange = this._onVariantChange.bind(this);
      this._section = null;
    }

    connectedCallback() {
      this._section = this.closest('[data-section-id]');
      if (!this._section) return;
      this._typeEl = this.querySelector('[data-variant-sale-type]');
      this._amountEl = this.querySelector('[data-variant-sale-amount]');
      if (!this._amountEl) {
        var wrap = document.createElement('span');
        wrap.setAttribute('data-variant-sale-amount', '');
        this.appendChild(wrap);
        this._amountEl = wrap;
      }
      this._section.addEventListener('theme:variant:change', this._boundOnVariantChange);
    }

    disconnectedCallback() {
      if (this._section) {
        this._section.removeEventListener('theme:variant:change', this._boundOnVariantChange);
      }
    }

    _onVariantChange(evt) {
      var variant = evt.detail && evt.detail.variant;
      if (!variant) {
        this.classList.add('hide');
        this.style.display = 'none';
        return;
      }
      var compareAt = variant.compare_at_price;
      var price = variant.price;
      if (compareAt != null && price != null && compareAt > price) {
        if (this._typeEl) {
          this._typeEl.textContent = (window.theme && window.theme.strings && window.theme.strings.sale) || 'Sale';
        }
        var badgeType = window.theme && window.theme.settings && window.theme.settings.badge_sale_type;
        if (badgeType === 'percentage') {
          var discountFloat = (compareAt - price) / compareAt;
          this._amountEl.textContent = Math.floor(discountFloat * 100) + '%';
        } else {
          this._amountEl.textContent = this._formatMoney(compareAt - price);
        }
        this.classList.remove('hide');
        this.style.display = '';
      } else {
        this.classList.add('hide');
        this.style.display = 'none';
      }
    }

    _formatMoney(cents) {
      var theme = window.theme;
      if (theme && theme.moneyFormat) {
        var str = formatMoney(cents, theme.moneyFormat);
        if (theme.settings && theme.settings.currency_code_enable && theme.currencyCode) {
          return str + ' ' + theme.currencyCode;
        }
        return str;
      }
      return formatMoney(cents);
    }
  }

  if (!window.customElements.get('variant-sale-save')) {
    window.customElements.define('variant-sale-save', VariantSaleSave);
  }
})();
